let csrfToken: string | null = null;
let csrfTokenPromise: Promise<string> | null = null;

const fetchCsrfToken = async (apiUrl: string): Promise<string> => {
	const response = await fetch(`${apiUrl}/api/security/csrf-token`, {
		credentials: "include",
		headers: {
			"Cache-Control": "no-cache",
		},
	});

	// If user is not authenticated (401), return empty token
	// Unauthenticated users can't perform protected operations anyway
	// and the CSRF token is tied to session ID
	if (response.status === 401) {
		csrfToken = "";
		return csrfToken;
	}

	if (!response.ok) {
		throw new Error("Failed to fetch CSRF token");
	}

	const payload = (await response.json()) as { token?: string };

	if (!payload.token) {
		throw new Error("CSRF token missing in response");
	}

	csrfToken = payload.token;
	return csrfToken;
};

export const getCsrfToken = async (
	apiUrl: string,
	forceRefresh = false,
): Promise<string> => {
	if (forceRefresh) {
		csrfToken = null;
		csrfTokenPromise = null;
	}

	if (csrfToken) {
		return csrfToken;
	}

	if (!csrfTokenPromise) {
		csrfTokenPromise = fetchCsrfToken(apiUrl).finally(() => {
			csrfTokenPromise = null;
		});
	}

	return await csrfTokenPromise;
};

/**
 * Invalidate the cached CSRF token.
 * Should be called when the session changes (sign-in, sign-out, sign-up).
 */
export const invalidateCsrfToken = (): void => {
	csrfToken = null;
	csrfTokenPromise = null;
};
